import { Outlet } from '@tanstack/react-router';
import { ReactElement } from 'react';
import Launch from '../assets/shapes/launch.svg';
import Empower from '../assets/shapes/empower.svg';

export const Unauthenticated = (): ReactElement => (
  <div className="relative flex w-full h-full overflow-hidden">
    <Launch className="absolute left-0 top-1/2 -translate-y-1/2 h-3/4 w-auto opacity-4 pointer-events-none" />
    <Empower className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-[70%] h-full w-auto opacity-4 pointer-events-none" />
    <Outlet />
  </div>
);
